// Web shim for react-native-vector-icons/MaterialCommunityIcons
// Uses Material Design Icons web font rendered via a raw DOM element
import React from 'react';

// Load MDI web font
if (typeof document !== 'undefined') {
  const linkId = '__mdi_font__';
  if (!document.getElementById(linkId)) {
    const link = document.createElement('link');
    link.id = linkId;
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@mdi/font@7/css/materialdesignicons.min.css';
    document.head.appendChild(link);
  }
}

function Icon({ name, size = 24, color = '#000', style, onPress, ...props }) {
  const className = `mdi mdi-${name}`;

  const iconStyle = {
    fontSize: size,
    color,
    lineHeight: `${size}px`,
    width: size,
    height: size,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    ...(typeof style === 'object' && !Array.isArray(style) ? style : {}),
    cursor: onPress ? 'pointer' : undefined,
  };

  // Use raw DOM element since react-native-web View/Text don't accept <i> children
  return (
    <i
      className={className}
      style={iconStyle}
      onClick={onPress}
      role={onPress ? 'button' : undefined}
    />
  );
}

Icon.getImageSource = () => Promise.resolve({ uri: '' });
Icon.getImageSourceSync = () => ({ uri: '' });
Icon.loadFont = () => Promise.resolve();
Icon.hasIcon = () => true;
Icon.Button = function IconButton({ name, size, color, children, onPress, style, ...props }) {
  return (
    <div
      onClick={onPress}
      style={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        ...(typeof style === 'object' && !Array.isArray(style) ? style : {}),
      }}
    >
      <Icon name={name} size={size} color={color} />
      {children}
    </div>
  );
};

export default Icon;
